import React from 'react'
import { Container, Col, InputContainer, Text, Icon, CheckboxContainer } from './styles'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons'
import Button from 'Components/Button'
import Input from 'Components/Input/TextInput'
import spinner from 'Assets/loading-spinner.gif'
import { useWindowDimensions } from 'Components/WindowDimensions'
import { BREAKPOINTS } from 'Global/constants'
import Checkbox from '../../Input/checkbox'

const CHECKBOX_TEXT = 'De acuerdo a la Ley Nº 19.996 de 03/11/2021 artículo 181 y su Decreto Reglamentario N° 132/022,' +
' autorizo a TenesSeguro.com a contactarme a los efectos de asesorarme en la contratación de seguros.'

export const Sms = (props) => {
  const {
    value,
    validator,
    onChangePhone,
    onChangeValidator,
    requestCode,
    verifyCode,
    sentRequest,
    sentVerification,
    formState,
    validatedCaptcha,
    valueCheckbox,
    handleClickCheckbox
  } = props

  const margin = '8px 0px 0px 10px'
  const device = useWindowDimensions()

  console.log('valueCheckbox', valueCheckbox)
  return (
    <Container device={device}>
      <Col width='35%'>
        <Icon>
          <FontAwesomeIcon size='6x' icon={faMobileAlt} />
        </Icon>
      </Col>
      <Col width={device === BREAKPOINTS.MOBILE ? '100%' : '60%'}>
        <Text style={{ marginTop: '10px', textAlign: 'left', width: '100%' }}>
          Ingrese un número de celular para la verificación
        </Text>
        <CheckboxContainer>
          <Checkbox
            name={CHECKBOX_TEXT}
            value={valueCheckbox.value}
            color='primary'
            onChange={val => { handleClickCheckbox({ ...valueCheckbox, value: val.value }) }}
            disabled={valueCheckbox.disabled}
          />
        </CheckboxContainer>
        <InputContainer device={device}>
          <Input disabled={sentRequest} value={value} type='text' onChange={onChangePhone} />
          {
            !formState.isLoading &&
              <Button style={{ padding: 0 }} disabled={validatedCaptcha || !valueCheckbox.value} onClick={requestCode} margin={margin} size='small'>
                Enviar
              </Button>
          }
          {
            formState.isLoading &&
              <img style={{ marginTop: '5px' }} width='50px' height='50px' src={spinner} />
          }
        </InputContainer>

        <Text style={{ marginTop: '10px', textAlign: 'left', width: '100%' }}>Ingrese el código que recibió en el SMS</Text>
        <InputContainer device={device}>
          <Input
            disabled={formState.isFirstRun | formState.isLoading}
            value={validator} type='text'
            onChange={onChangeValidator}
          />
          <Button
            style={{ borderRadius: '8px', padding: 0, height: '32px' }}
            disabled={sentVerification | formState.isFirstRun | formState.isLoading} onClick={verifyCode}
            margin={margin}
            size='small'
          >
              Verificar
          </Button>
        </InputContainer>

      </Col>
    </Container>
  )
}
export default Sms
